var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconlicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_954_3152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 5H3.33329C2.89127 5 2.46734 5.17559 2.15478 5.48816C1.84222 5.80072 1.66663 6.22464 1.66663 6.66667V23.3333C1.66663 23.7754 1.84222 24.1993 2.15478 24.5118C2.46734 24.8244 2.89127 25 3.33329 25H15.8333L16.3083 24.4167L17.0833 23.4667L17.0083 23.3333H3.33329V6.66667H26.6666V13.8C27.2997 14.2098 27.8625 14.7192 28.3333 15.3083V6.66667C28.3333 6.22464 28.1577 5.80072 27.8451 5.48816C27.5326 5.17559 27.1087 5 26.6666 5Z",
    fill: "#F66524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 10H20V11.3333H5.83337V10Z",
    fill: "#F66524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 13.3333H15V14.6666H5.83337V13.3333Z",
    fill: "#F66524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 19.1667H14.1667V20.5001H5.83337V19.1667Z",
    fill: "#F66524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8833 14.3583C21.817 14.3499 20.7728 14.6633 19.8874 15.2576C19.0019 15.852 18.3164 16.6996 17.9203 17.6898C17.5243 18.6799 17.4361 19.7665 17.6674 20.8076C17.8987 21.8486 18.4386 22.7957 19.2167 23.525L17.6 25.5L18.35 28.5083L21.4 24.7917C22.3655 25.0771 23.3929 25.0771 24.3583 24.7917L27.4083 28.5083L28.1583 25.5L26.5417 23.525C27.3197 22.7957 27.8597 21.8486 28.091 20.8076C28.3222 19.7665 28.2341 18.6799 27.838 17.6898C27.442 16.6996 26.7564 15.852 25.871 15.2576C24.9855 14.6633 23.9414 14.3499 22.875 14.3583H22.8833ZM22.8833 23.2583C22.1752 23.2485 21.4858 23.0295 20.9017 22.6289C20.3177 22.2283 19.8651 21.6639 19.6009 21.0068C19.3367 20.3497 19.2727 19.6292 19.4169 18.9358C19.5611 18.2424 19.907 17.6071 20.4113 17.1098C20.9155 16.6125 21.5555 16.2754 22.2508 16.1408C22.9461 16.0062 23.6657 16.0802 24.3191 16.3534C24.9725 16.6267 25.5305 17.087 25.923 17.6765C26.3155 18.266 26.5249 18.9584 26.525 19.6667C26.5162 20.6252 26.1281 21.5412 25.4456 22.2143C24.7632 22.8874 23.8419 23.2628 22.8833 23.2583Z",
    fill: "#F66524"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_954_3152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlicense);
export default __webpack_public_path__ + "static/media/Iconlicense.610a2e37d8f85f755523e0052e6ba81e.svg";
export { ForwardRef as ReactComponent };